var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { defaultProps } from './defaults';
import Tooltip from '../Tooltip';
import Overlay from './overlay';
var Popover = /** @class */ (function (_super) {
    __extends(Popover, _super);
    function Popover(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    Popover.prototype.render = function () {
        var _a = this.props, children = _a.children, triggerEvent = _a.triggerEvent, title = _a.title, content = _a.content, overlayClassName = _a.overlayClassName, placement = _a.placement, backgroundColor = _a.backgroundColor, defaultVisible = _a.defaultVisible;
        var over = React.createElement(Overlay, { title: title, content: content });
        return (React.createElement(Tooltip, { title: over, placement: placement, trigger: triggerEvent, backgroundColor: backgroundColor, className: (overlayClassName ? overlayClassName : '') + " legao-popover", defaultVisible: defaultVisible }, children));
    };
    Popover.NAME = 'Popover';
    Popover.defaultProps = defaultProps;
    return Popover;
}(React.Component));
export { Popover };
